import { Endpoint, ToastService } from '@philips-emr/hpms-provider-commons';
import { DeckAPI, FetchAPI } from '@philips-emr/tws-components';
import { ToastLevel } from '@philips-emr/tws-constants';
import Controller, { OnMount, OnSelectItem } from '@philips-emr/tws-core/lib/client';
import { MountEvent, SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';
import { FileService, MessageService } from '@philips-emr/tws-core/lib/services';
import { HttpMethod } from '@philips-emr/tws-core/lib/services/http-service';

import { FragmentNames } from '../../codegen';
import { ContractAttachmentsAliases as Aliases } from '../../codegen/constants/aliases/contract-attachments-aliases';
import BaseController from '../BaseController';

interface ContractAttachment {
  fileName: string,
  pathAttachment: string,
  nrSeqContractAttachment: number,
  fileExtension: string,
}

@Controller({ fragment: FragmentNames.CONTRACT_ATTACHMENTS })
class ContractAttachmentsController extends BaseController {

  @OnMount(Aliases.FETCH_ATTACHMENTS)
  onMountFetch(event: MountEvent): void {
    const { nrSeqContract } = this.historyService.getCurrentRouteParams();
    const api = event.target as FetchAPI;
    api.setParameters({ nrSeqContract });
    api.forceFetch();
  }

  @OnSelectItem(Aliases.DECK_ATTACHMENTS)
  onSelectAttachment(event: SelectItemEvent<ContractAttachment>): void {
    const api = event.target as unknown as DeckAPI;
    const { fileExtension, nrSeqContractAttachment } = event.item;
    const { nrSeqContract } = this.historyService.getCurrentRouteParams();
    
    FileService.download(Endpoint.GET.CONTRACT_ATTACHMENT, fileExtension, { nrSeqContract, nrSeqContractAttachment }, HttpMethod.GET).then(() => {
      ToastService.open({ message: MessageService.translate('provider.download-initiated'), level: ToastLevel.SUCCESS });
      api.unselectAll();
    }).catch(() => {
      ToastService.open({ message: MessageService.translate('provider.error-finding-file'), level: ToastLevel.ERROR });
      api.unselectAll();
    });
  }

}

export {
  ContractAttachmentsController,
}
;
